/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q12Inputs */

const en_pc_faq_q12 = /** @type {(inputs: Pc_Faq_Q12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the same as the PDFCraft browser toolkit on GitHub?`)
};

const zh_pc_faq_q12 = /** @type {(inputs: Pc_Faq_Q12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本站介绍的和 GitHub 上那个 PDFCraft 浏览器工具集是同一个吗？`)
};

/**
* | output |
* | --- |
* | "Is this the same as the PDFCraft browser toolkit on GitHub?" |
*
* @param {Pc_Faq_Q12Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q12 = /** @type {((inputs?: Pc_Faq_Q12Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q12Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q12(inputs)
	return zh_pc_faq_q12(inputs)
});
export { pc_faq_q12 as "pc.faq.q12" }